import { Button } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";

export const NextButton = ({
  size,
  action,
  disabled,
}: {
  size?: "xs" | "sm" | "md";
  action: () => void;
  disabled?: boolean;
}) => {
  const { language } = useLanguage();

  return (
    <Button
      fill="fill"
      type="primary"
      size={size}
      onClick={action}
      disabled={disabled}
    >
      {language === "bn" ? "পরবর্তী" : "Next"}
    </Button>
  );
};
